import Dialog from "../1. Core/Controls/Dialog/Dialog";
import TextField from "../1. Core/Controls/TextField/TextField";
import NumField from "../1. Core/Controls/TextField/NumField";
import NP from "../1. Core/NP";
import {
	getCountries,
	getStates,
	getTournaments,
	getWeights,
	getWeightString,
	ITournament,
	Weight
} from "../10. Battle/Util";
import {ServerAPI} from "../1. Core/ServerAPI";
import AthletesList from "./AthletesList";
import IconSelect from "../1. Core/Controls/Select/IconSelect";
import {IState} from "./StatesList";
import Select from "../1. Core/Controls/Select/Select";
import './EditAthleteDialog.scss';
import {IAthlete, IBattle, SportType, Trainer} from "../10. Battle/types";
import ImageTextField from "../1. Core/Controls/TextField/ImageTextField";
import TabControl from "../1. Core/Controls/TabControl/TabControl";
import Button from "../1. Core/Controls/Button/Button";
import DateInput from "../1. Core/Controls/DateInput/DateInput";
import DataTable from "../1. Core/Controls/DataTable/DataTable";
import IconToggleButton from "../1. Core/Controls/IconToggleButton/IconToggleButton";
import Menu from "../1. Core/Controls/Menu/Menu";

let moment = require('moment');

export default class EditAthleteDialog extends Dialog {

	_Athlete: IAthlete;

	_avatarURLInput: ImageTextField;
	_photoURLInput: ImageTextField;
	_flagURLInput: ImageTextField;
	_firstNameField: TextField;
	_lastNameField: TextField;
	_genderCombo: IconSelect;
	_weightCombo: IconSelect;
	_dateOfBirthField: DateInput;
	_cityField: TextField;
	_statesSelectBox: Select;
	_sportCategoryField: Select;
	_tournamentCombo: Select;
	private _firstNameFieldRU: TextField;
	private _lastNameFieldRU: TextField;
	private _siteFirstNameFieldRU: TextField;
	private _siteLastNameFieldRU: TextField;
	private _stanceSelect: Select;
	private _countryCombo: Select;


	private _avatarContainer: HTMLElement;
	private _avatarImage: HTMLImageElement;


	private _kField: NumField;
	private _xKOField: NumField;
	private _yKOField: NumField;
	private _totalLessThan6Field: NumField;
	private _totalMoreThan6Field: NumField;
	private _total12Field: NumField;
	private _heightField: TextField;
	private _armSpanField: TextField;
	private _winRecord: NumField;
	private _drawRecord: NumField;
	private _loseRecord: NumField;
	private _baseStyleField: TextField;

	private _nickNameField: TextField;
	private _weightValue: TextField;
	private _SportType: SportType;
	private _ratingField: Select;
	private _idValue: TextField;
	private _trainerCombo: Select;
	private _tabs: TabControl;
	private _generalNode: HTMLElement;

	private _otherNode: HTMLElement;
	private _sportClub: TextField;
	private _tapologyUrl: TextField;
	private _sherdogUrl: TextField;
	private _ufcUrl: TextField;
	private _espnUrl: TextField;
	private _topologyLink: string;

	_initFields(settings: object)
	{
		this._Athlete = null;
		this._SportType = SportType.MMA;
		super._initFields(settings);
		this._Mode = 'FullHeight';
		this._Caption = this._Athlete ? NP.RM.getString('Athlete') : NP.RM.getString('AddAthlete');
		this._CloseOnFrameMouseDown = true;
		this._ShowHeader = true;
		this._ShowCloseButton = true;
		this._OkRK = 'Save'
		this._Width = 500;
	}

	_render()
	{
		super._render();

		this._avatarContainer = NP.createNode(this._contentNode, 'edit-athlete-dialog__avatar-container');
		this._avatarImage = NP.createNode(this._avatarContainer, 'edit-athlete-dialog__avatar', 'img');

		this._tabs = new TabControl({
			ParentNode: this._contentNode,
			Items: [
				{Value: 'General', Content: 'General'},
				{Value: 'Career', Content: 'Career'}
			],
			EvTabSelected: () =>
			{
				NP.setIsVisible([this._generalNode, this._otherNode], false)
				switch (this._tabs.getValue())
				{
					case 'General':
						NP.setIsVisible(this._generalNode, true)
						break;
					case 'Career':
						NP.setIsVisible(this._otherNode, true)
						break;
				}
			}
		});


		if (this._Athlete?.Id)
		{
			this._topAppBar.addRightItem(new IconToggleButton({
				FontImage: NP.FontImages.more_vert,
				Menu: new Menu({
					Items: [
						{
							Content: `Show Record`,
							EvClick: () => window.open(`/mmaathletes/${this._Athlete.Id}`)
						},
						{
							Content: 'Load athlete info',
							EvClick: () =>
							{
								(new Dialog({
									Caption: 'Insert ShareDog link',
									ShowHeader: true,
									Content: new TextField({}),
									EvOkButtonClick: (dlg: Dialog) => this.parseShareDogLink(dlg.getContent().getValue())
								})).show()
							}
						},
						{
							Content: 'Load records',
							EvClick: () =>
							{
								(new Dialog({
									Caption: 'Load records from Topology link',
									ShowHeader: true,
									Content: new TextField({}),
									EvOkButtonClick: (dlg: Dialog) => this.loadRecords(dlg.getContent().getValue())
								})).show()
							}
						}
					]
				})
			}));
		}
		else
		{
			let topoBtn = new Button({
				Content: `<img src="/static/img/topology.png"/>`,
				ToolTip: 'Parse data from ShareDog',
				EvClick: () =>
				{
					(new Dialog({
						Caption: 'Insert ShareDog link',
						ShowHeader: true,
						Content: new TextField({}),
						EvOkButtonClick: (dlg: Dialog) => this.parseShareDogLink(dlg.getContent().getValue())
					})).show()
				}
			});
			topoBtn.getRoot().style.minWidth = '0px';
			this._topAppBar.addRightItem(topoBtn)
		}

		this._generalNode = NP.createNode(this._contentNode)

		this._photoURLInput = new ImageTextField({
			ParentNode: this._generalNode,
			TextFieldSettings: {
				FloatingLabel: NP.RM.getString('PhotoUrl')
			},
			EvChanged: () =>
			{
				this._Athlete.PhotoUrl = this._photoURLInput.getValue();
				this.refreshAvatar();
			}
		});


		this._flagURLInput = new ImageTextField({
			ParentNode: this._generalNode,
			TextFieldSettings: {
				FloatingLabel: NP.RM.getString('FlagUrl')
			}
		});


		this._firstNameField = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('FirstName'),
			EvChanged: () => this._updateActionButtonsEnable()
		});

		this._lastNameField = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('LastName'),
			EvChanged: () => this._updateActionButtonsEnable()
		});

		this._firstNameFieldRU = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('FirstNameRU'),
			EvChanged: () => this._updateActionButtonsEnable()
		});

		this._lastNameFieldRU = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('LastNameRU'),
			EvChanged: () => this._updateActionButtonsEnable()
		});

		this._siteFirstNameFieldRU = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: 'Site FirstName RU',
			EvChanged: () => this._updateActionButtonsEnable()
		});

		this._siteLastNameFieldRU = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: 'Site LastName RU',
			EvChanged: () => this._updateActionButtonsEnable()
		});

		this._nickNameField = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('Nickname')
		});


		this._genderCombo = new IconSelect({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('Gender'),
			SelectedIndex: 0,
			Items: [{
				Value: 1,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('MaleSex')
			}, {
				Value: 0,
				FontImage: NP.FontImages.gender,
				Content: NP.RM.getString('FemaleSex')
			}],
			EvItemSelected: () => this.updateWeight()
		});

		this._dateOfBirthField = new DateInput({
			ParentNode: this._generalNode,
			Value: null,
			FloatingLabel: NP.RM.getString('DateBirth'),
			EvChanged: () => this._updateActionButtonsEnable()
		});

		this._countryCombo = new Select({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('Country'),
			SelectedIndex: 0,
			Items: [{
				Value: null,
				FontImage: NP.FontImages.geo,
				Content: NP.RM.getString('All')
			}],
			EvItemSelected: () => this.updateStatesList()
		});

		this._statesSelectBox = new Select({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('State')
		});

		this._cityField = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('City')
		});


		this._tournamentCombo = new Select({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('Tournament')
		});

		this._sportClub = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('SportClub')
		});

		this._ratingField = new Select({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('Rating2'),
			Items: [{Content: '', Value: null}, {Content: 'C', Value: 'C'}]
		});

		[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].forEach(i =>
		{
			this._ratingField.addItem({Content: i + '', Value: i})
		})

		this._stanceSelect = new Select({
			Items: [{
				RK: 'RightSide',
				Value: 'RightSide'
			}, {
				RK: 'LeftSide',
				Value: 'LeftSide'
			}, {
				RK: 'Universal',
				Value: 'Universal'
			}],
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('Stance')
		});


		this._weightCombo = new IconSelect({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('WeightCategory')
		});

		this._weightValue = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('Weight')
		});

		this._heightField = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('HeightAthlete')
		});

		this._armSpanField = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('ArmSpan')
		});

		this._baseStyleField = new TextField({
			ParentNode: this._generalNode,
			FloatingLabel: NP.RM.getString('BaseStyle')
		});


		//-----------------------other
		this._otherNode = NP.createNode(this._contentNode)

		this._avatarURLInput = new ImageTextField({
			ParentNode: this._otherNode,
			TextFieldSettings: {
				FloatingLabel: NP.RM.getString('AvatarUrl')
			}
		});
		this._idValue = new TextField({
			ParentNode: this._otherNode,
			FloatingLabel: 'Id',
			EnableEdit: true
		});
		this._tapologyUrl = new TextField({ ParentNode: this._otherNode, FloatingLabel: 'Tapology profile URL' });
		this._sherdogUrl = new TextField({ ParentNode: this._otherNode, FloatingLabel: 'Sherdog profile URL' });
		this._ufcUrl = new TextField({ ParentNode: this._otherNode, FloatingLabel: 'UFC profile URL' });
		this._espnUrl = new TextField({ ParentNode: this._otherNode, FloatingLabel: 'ESPN profile URL' });

		this._sportCategoryField = new Select({
			ParentNode: this._otherNode,
			FloatingLabel: NP.RM.getString('SportCategory'),
			Items: [
				{RK: 'IMS', Value: 'IMS'},
				{RK: 'HMS', Value: 'HMS'},
				{RK: 'SP', Value: 'SP'},
				{RK: 'CIS', Value: 'CIS'},
				{RK: 'Adult1', Value: 'Adult1'},
				{RK: 'Adult2', Value: 'Adult2'},
				{RK: 'Adult3', Value: 'Adult3'},
				{RK: 'Youth1', Value: 'Youth1'},
				{RK: 'Youth2', Value: 'Youth2'},
				{RK: 'Youth3', Value: 'Youth3'}
			]
		});

		this._trainerCombo = new Select({
			ParentNode: this._otherNode,
			FloatingLabel: NP.RM.getString('Trainer')
		});


		this._xKOField = new NumField({
			ParentNode: this._otherNode,
			FloatingLabel: NP.RM.getString('xKO'),
			FractionCount: 2
		});

		this._yKOField = new NumField({
			ParentNode: this._otherNode,
			FloatingLabel: NP.RM.getString('yKO'),
			FractionCount: 2
		});

		this._totalLessThan6Field = new NumField({
			ParentNode: this._otherNode,
			FloatingLabel: NP.RM.getString('TotalLessThan6'),
			FractionCount: 2
		});

		this._totalMoreThan6Field = new NumField({
			ParentNode: this._otherNode,
			FloatingLabel: NP.RM.getString('TotalMoreThan6'),
			FractionCount: 2
		});

		this._total12Field = new NumField({
			ParentNode: this._otherNode,
			FloatingLabel: NP.RM.getString('Total12'),
			FractionCount: 2
		});

		this._kField = new NumField({
			ParentNode: this._otherNode,
			FloatingLabel: NP.RM.getString('CorrectionOfCoefficient'),
			FractionCount: 2
		});


		this._winRecord = new NumField({
			ParentNode: this._otherNode,
			Min: 0,
			FloatingLabel: NP.RM.getString('WinRecord'),
			FractionCount: 0
		});

		this._drawRecord = new NumField({
			ParentNode: this._otherNode,
			Min: 0,
			FloatingLabel: NP.RM.getString('DrawRecord'),
			FractionCount: 0
		});

		this._loseRecord = new NumField({
			ParentNode: this._otherNode,
			Min: 0,
			FloatingLabel: NP.RM.getString('LoseRecord'),
			FractionCount: 0
		});


		//NP.setIsVisible([this._firstNameFieldRU, this._lastNameFieldRU], NP.getCurrentUser().getRegionalSettings().Lang == 'ru');

		NP.setIsVisible([this._xKOField, this._yKOField, this._totalLessThan6Field, this._totalMoreThan6Field, this._total12Field, this._kField], false)

		getTournaments(this._SportType).then((res: ITournament[]) =>
		{
			if (this._tournamentCombo)
			{
				let items = res.map(t => ({Value: t.Id, FontImage: NP.FontImages.event, Content: t.Name, Data: t}));
				this._tournamentCombo.setItems(items);
				this._tournamentCombo.setValue(this._Athlete && this._Athlete.TournamentIds ? this._Athlete.TournamentIds[0] : null);
			}
		});

		ServerAPI.get<Trainer[]>("/trainers").then((res: Trainer[]) =>
		{
			if (this._trainerCombo)
			{
				let items = [{RK: 'None'}, ...res.map(t => ({
					Value: t.Id,
					FontImage: NP.FontImages.event,
					Content: t.FirstName + " " + t.LastName,
					Data: t
				}))];

				this._trainerCombo.setItems(items);
				if (this._Athlete)
					this._trainerCombo.setValue(this._Athlete.TrainerId);
			}
		})

		this._tabs.setSelectedIndex(0, true, true)
	}

	async updateStatesList()
	{
		let states = await getStates(this._countryCombo.getValue())

		this._statesSelectBox.setItems(states.map(state => ({
			Value: state.Id,
			Content: state.Name
		})));
		if (this._Athlete && this._Athlete.StateIds)
			this._statesSelectBox.setValue(this._Athlete.StateIds[0]);
	}

	async loadRecords(url: string)
	{
		try
		{
			this._topAppBar.showWaiter()

			let parseResult = await ServerAPI.post<ParseTopologyRecordResult>(`/topology/record`, {
				athleteId: this._Athlete.Id,
				html: url,
				gender: this._genderCombo.getValue()
			})


			let dlg = new Dialog({
				ShowHeader: true,
				Width: 900,
				Mode: 'FullHeight',
				Caption: 'Load record',
				Class: 'nopad',
				ContentAutoFit: true,
				Content: new DataTable({
					Class: `mdc-data-table--margin`,
					Rows: parseResult.battles.map(m =>
					{
						let row = {
							Opponent: `${m.athlete.FirstName} ${m.athlete.LastName}`,
							Date: `${m.battle.Date.replace('00:00:00.0', '')}`,
							Result: m.battle.Status,
							WinType: m.battle.WinType,
							EndTime: m.battle.EndTime,
							EventInfo: m.battle.EventInfo
						};

						if (m.battle.Winner == this._Athlete.Id)
							row.Result = 'Win'
						else if (m.battle.Winner != null)
							row.Result = 'Loss'
						else if (m.battle.Status != 'Canceled')
							row.Result = 'Draw'

						if (m.eventExists)
							row.EventInfo = `<span style="color: green">${row.EventInfo} </span>`

						if (m.athleteExists)
							row.Opponent = `<a target="_blank" href="/mmaathletes/${m.athlete.Id}">${row.Opponent}</a>`

						if (m.battleExists)
							row.Result = `<span style="color: green">${row.Result} </span>`

						return row;
					}),
					Columns: [{
						Content: NP.RM.getString('Opponent'),
						HtmlPropertyContent: 'Opponent',
						Width: '25%'
					}, {
						Content: NP.RM.getString('Date'),
						Width: '15%',
						PropertyContent: 'Date'
					}, {
						Content: NP.RM.getString('Result'),
						HtmlPropertyContent: 'Result',
						Width: '10%'
					}, {
						Content: NP.RM.getString('WinType2'),
						PropertyContent: 'WinType',
						Width: '10%'
					}, {
						Content: 'End time',
						PropertyContent: 'EndTime',
						Width: '10%'
					}, {
						Content: 'Event',
						HtmlPropertyContent: 'EventInfo',
						Width: '30%'
					}]
				})
			});

			dlg._contentNode.style.overflow = 'hidden'
			dlg.show();
			dlg.getCancelButton().setIsVisible(false);

			dlg.getOkButton().setContent('Import non exists athletes, battles and events')

			dlg.EvOkButtonClick.add(async () =>
			{
				await ServerAPI.post<ParseTopologyRecordResult>(`/topology/import-data/${this._Athlete.Id}`, parseResult)
				NP.showMessage({
					RK: 'Done'
				})
			})

		} finally
		{
			this._topAppBar.hideWaiter()
		}
	}


	async parseShareDogLink(url: string)
	{
		if (!url)
			return;
		this._topAppBar.showWaiter();
		try
		{

			let parseAthlete = await ServerAPI.post<IAthlete>(`/sharedog/athlete`, {
				html: url,
				sportType: this._SportType,
				gender: this._genderCombo.getValue()
			})

			this._nickNameField.setValue(parseAthlete.Nickname)


			this._firstNameField.setValue(parseAthlete.FirstName);
			this._lastNameField.setValue(parseAthlete.LastName);


			this._weightCombo.setValue(parseAthlete.WeightCategory, false);

			this._dateOfBirthField.setValue(parseAthlete.DateBirth ? moment(parseAthlete.DateBirth).toDate() : null);

			this._heightField.setValue(parseAthlete.Height);
			this._weightValue.setValue(parseAthlete.Weight);


			this._baseStyleField.setValue(parseAthlete.BaseStyle);


			this._armSpanField.setValue(parseAthlete.ArmSpan)


			if (parseAthlete.CountryId)
			{
				this._countryCombo.setValue(parseAthlete.CountryId, false);
				await this.updateStatesList();

				if (parseAthlete.StateIds)
				{
					let stateId = parseAthlete.StateIds[0]
					if (stateId)
						this._statesSelectBox.setValue(stateId, false);
				}
			}

			this._cityField.setValue(parseAthlete.City);

			this._sportClub.setValue(parseAthlete.SportClub);


			this._updateActionButtonsEnable();


			this._topologyLink = url;

		} finally
		{
			this._topAppBar.hideWaiter()
		}
	}

	setDefaultAvatar()
	{
		this._avatarImage.src = AthletesList.getDefaultAthleteImageUrl();
		this._avatarImage.style.backgroundColor = "#9E9E9E";
	}

	setAvatar(imageUrl: string)
	{
		this._avatarImage.src = imageUrl;
		this._avatarImage.style.backgroundColor = "";
	}

	refreshAvatar()
	{
		if (this._Athlete && this._Athlete.PhotoUrl)
			this.setAvatar(this._Athlete.PhotoUrl);
		else
			this.setDefaultAvatar();
	}

	refresh()
	{
		this.refreshAvatar();
		if (this._Athlete)
		{
			ServerAPI.callUiApi(`/athlete/${this._Athlete.Id}`).then((res: IAthlete) =>
			{
				this._Athlete = res;

				if (this._Athlete.Weight)
					this._weightValue.setValue(this._Athlete.Weight);

				this._idValue.setValue(this._Athlete.GloryFighterID);
				this._ratingField.setValue(this._Athlete.Rating);

				this._nickNameField.setValue(this._Athlete.Nickname);
				this._photoURLInput.setValue(this._Athlete.PhotoUrl);
				this._avatarURLInput.setValue(this._Athlete.AvatarUrl);
				this._flagURLInput.setValue(this._Athlete.FlagUrl);
				this._firstNameField.setValue(this._Athlete.FirstName);
				this._lastNameField.setValue(this._Athlete.LastName);
				this._firstNameFieldRU.setValue(this._Athlete.FirstNameRU);
				this._lastNameFieldRU.setValue(this._Athlete.LastNameRU);
				this._siteFirstNameFieldRU.setValue(this._Athlete.SiteFirstNameRU);
				this._siteLastNameFieldRU.setValue(this._Athlete.SiteLastNameRU);
				this._genderCombo.setValue(this._Athlete.Sex);

				this._dateOfBirthField.setValue(this._Athlete.DateBirth ? moment(this._Athlete.DateBirth).toDate() : null);

				this._cityField.setValue(this._Athlete.City);
				this._sportCategoryField.setValue(this._Athlete.SportCategory);
				this._tournamentCombo.setValue(this._Athlete.TournamentIds && this._Athlete.TournamentIds[0]);
				this._stanceSelect.setValue(this._Athlete.Stance);

				this._xKOField.setValue(this._Athlete.XKO);
				this._yKOField.setValue(this._Athlete.YKO);
				this._totalLessThan6Field.setValue(this._Athlete.TotalLessThan6);
				this._totalMoreThan6Field.setValue(this._Athlete.TotalMoreThan6);
				this._total12Field.setValue(this._Athlete.Total12);

				this._kField.setValue(this._Athlete.K);

				this._heightField.setValue(this._Athlete.Height);
				this._armSpanField.setValue(this._Athlete.ArmSpan);
				this._winRecord.setValue(this._Athlete.WinRecord);
				this._drawRecord.setValue(this._Athlete.DrawRecord);
				this._loseRecord.setValue(this._Athlete.LoseRecord);
				this._baseStyleField.setValue(this._Athlete.BaseStyle);

				this._sportClub.setValue(this._Athlete.SportClub);
				this._tapologyUrl.setValue(this._Athlete.TapologyUrl);
				this._sherdogUrl.setValue(this._Athlete.SherdogUrl);
				this._ufcUrl.setValue(this._Athlete.UfcUrl);
				this._espnUrl.setValue(this._Athlete.EspnUrl);
				this._trainerCombo.setValue(this._Athlete.TrainerId);

				if (this._Athlete.StateIds[0])
					this._stanceSelect.setValue(this._Athlete.StateIds[0]);

				this.refreshCombos();
				this._updateActionButtonsEnable();
			});
		}
		else
		{
			this.refreshCombos();
			this._updateActionButtonsEnable();
		}

		return this;
	}

	updateWeight()
	{
		getWeights({Type: this._Athlete ? this._Athlete.SportType : this._SportType}).then((res: Weight[]) =>
		{
			res = res.filter(w => w.Sex == this._genderCombo.getValue());

			let items = res.map(w => ({Value: w.Id, FontImage: NP.FontImages.weight, Content: getWeightString(w)}));

			this._weightCombo.setItems(items);
			if (this._Athlete)
				this._weightCombo.setValue(this._Athlete.WeightCategory);
		});
	}

	refreshCombos()
	{
		this.updateWeight();

		getCountries(true).then((res: IState[]) =>
		{
			let items = res.map(state => ({Value: state.Id, FontImage: NP.FontImages.geo, Content: state.Name}));
			if (this._countryCombo)
				this._countryCombo.setItems(items);
			if (this._Athlete)
				this._countryCombo.setValue(this._Athlete.CountryId);
		});
	}

	_updateActionButtonsEnable()
	{
		this.getOkButton().setEnabled(this._firstNameField.getValue() != '' || this._lastNameField.getValue() != '');
	}

	async _onOkButtonClick()
	{
		if (this._firstNameField.getValue() != '' || this._lastNameField.getValue() != '')
		{
			const payload = {
				GloryFighterID: this._idValue.getValue(),
				Id: this._Athlete ? this._Athlete.Id : null,
				PhotoUrl: this._photoURLInput.getValue().trim(),
				AvatarUrl: this._avatarURLInput.getValue().trim(),
				FlagUrl: this._flagURLInput.getValue().trim(),
				FirstName: this._firstNameField.getValue().trim(),
				LastName: this._lastNameField.getValue().trim(),
				Nickname: this._nickNameField.getValue(),
				FirstNameRU: this._firstNameFieldRU.getValue().trim(),
				LastNameRU: this._lastNameFieldRU.getValue().trim(),
				SiteFirstNameRU: this._siteFirstNameFieldRU.getValue().trim(),
				SiteLastNameRU: this._siteLastNameFieldRU.getValue().trim(),
				Sex: this._genderCombo.getValue(),
				WeightCategory: this._weightCombo.getValue(),
				DateBirth: this._dateOfBirthField.getValue() ? moment(this._dateOfBirthField.getValue()).format('YYYY-MM-DD HH:mm:ss.S') : null,
				City: this._cityField.getValue().trim(),
				SportCategory: this._sportCategoryField.getValue(),
				TournamentIds: this._tournamentCombo.getValue() ? [this._tournamentCombo.getValue()] : null,
				StateIds: [this._statesSelectBox.getValue()],
				Stance: this._stanceSelect.getValue(),
				CountryId: this._countryCombo.getValue(),
				Weight: this._weightValue.getValue(),
				XKO: this._xKOField.getValue(),
				YKO: this._yKOField.getValue(),
				TotalLessThan6: this._totalLessThan6Field.getValue(),
				TotalMoreThan6: this._totalMoreThan6Field.getValue(),
				Total12: this._total12Field.getValue(),
				Rating: this._ratingField.getValue(),
				K: this._kField.getValue(),

				Height: this._heightField.getValue(),
				ArmSpan: this._armSpanField.getValue(),
				WinRecord: this._winRecord.getValue(),
				DrawRecord: this._drawRecord.getValue(),
				LoseRecord: this._loseRecord.getValue(),
				BaseStyle: this._baseStyleField.getValue(),
				SportType: this._Athlete ? this._Athlete.SportType : this._SportType,
				TrainerId: this._trainerCombo.getValue(),
				SportClub: this._sportClub.getValue(),
				TapologyUrl: this._tapologyUrl.getValue().trim(),
				SherdogUrl: this._sherdogUrl.getValue().trim(),
				UfcUrl: this._ufcUrl.getValue().trim(),
				EspnUrl: this._espnUrl.getValue().trim()
			}

			if (NP.getCurrentUser().getRegionalSettings().Lang != 'ru')
			{
				if (!payload.LastName)
					payload.LastNameRU = null;

				if (!payload.FirstName)
					payload.FirstNameRU = null;
			}

			let id = await ServerAPI.post('/athlete' + (this._Athlete ? '/' + this._Athlete.Id : ''), payload) as number
			this.EvOkButtonClick.fire(this, {Id: id});


			if (this._topologyLink && !payload.Id)
			{
				payload.Id = id;
				let okClick = this.EvOkButtonClick.clone()
				let dlg = new EditAthleteDialog({
					Athlete: payload,
					SportType: this._SportType,
					EvOkButtonClick: () =>
					{
						okClick.fire(dlg, {Id: id})
					}
				})
				dlg.refresh()
				dlg.show()
				dlg.loadRecords(this._topologyLink)
			}

			this.hide();
		}
	}
}

interface ParseTopologyRecordResult {
	battles: {
		athlete: IAthlete,
		battle: IBattle,
		topoBout: any,
		battleExists: boolean,
		athleteExists: boolean
		eventExists: boolean
	}[]
}
